/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var SendForSignatureActionIcon = createIcon("SendForSignatureActionIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "m8.488 11.266 6.364-6.364 3.182 3.182-6.364 6.364-3.182-3.182Zm13.259-6.895 1.06 1.061a1.5 1.5 0 010 2.121l-4.773 4.773m0-4.242 3.713-3.713a1.5 1.5 0 000-2.121l-1.061-1.061a1.5 1.5 0 00-2.121 0L14.852 4.9",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.079 16.039c-.878.878-4.242 1.06-4.242 1.06s.182-3.364 1.06-4.242a2.25 2.25 0 013.182 3.182v0ZM3.747 18.75H3a2.25 2.25 0 000 4.5h15.75",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});